import React from 'react';
import './Home.css';

function Home() {
    return (
        <div className="home-container">
            <div className="header">
                {/* <img src="logo.png" alt="Logo" className="logo" /> */}
                {/* <h1>enin</h1> */}
                {/* <img src="images/logos/enin.jpg" alt="Logo" className="logo" /> */}
            </div>
            <p className="description">
                The Trusted Transaction Exchange/SAAS Platform runs on advanced technologies, innovative solutions and provides online transaction processing, data analytics & API services to companies and their suppliers, partners & IoT devices.
            </p>
            <p className="description">
                We lead the way through our intelligently connected services and embed extensive learnings to deliver valuable outcomes to our customers and their suppliers. State-of-the-art technology, innovation, and excellence in customer services are the key to our wide range of services.
            </p>
            <div className="icons-container">
                <div className="icon-item">
                    <div className="ic hexagon">
                        <span>&#x21ba;</span>
                    </div>
                    <p>Scan, Share, Track & Collect</p>
                </div>
                <div className="icon-item">
                    <div className="ic hexagon blue">
                        <span>&#10003;</span>
                    </div>
                    <p>Submit, Post, Check & Tally</p>
                </div>
            </div>
        </div>
    );
}

export default Home;
